module.exports = __webpack_public_path__ + "assets/images/spoke-logo-fdbee576d3ce6085cfe7bcc04f4da243.png";